/* eslint-disable @typescript-eslint/no-explicit-any */

import { Form, TimePicker } from "antd";
import { Controller } from "react-hook-form";
import { InfoIconOutlined } from "../../CustomIcons";
import dayjs from "dayjs";

export const TimePickerField = ({
  fieldName,
  isRequired = false, // Provide default value
  label,
  validMessage,
  className,
  control,
  defaultValue, // Provide default value
  rules,
  tooltipTitle,
  optionalLabel,
  hintMessage,
  warning,
  validate,
}: any) => {
  const formatTimeAsHoursMinutes = (time: dayjs.Dayjs | null): string => {
    if (!time) {
      return ""; // Return empty string if no time is selected
    }

    const hours = time.hour();
    const minutes = time.minute();

    const formattedParts: string[] = [];

    if (hours > 0) {
      formattedParts.push(`${hours} h`);
    }

    if (minutes > 0) {
      formattedParts.push(`${minutes} m`);
    }

    // Handle the case where both hours and minutes are zero (e.g., 00:00)
    if (hours === 0 && minutes === 0) {
      return "0 h 0 m"; // Or '0 m' if you prefer for 00:00
    }

    return formattedParts.join(" "); // Join with a space if both parts exist
  };

  // console.log("formatTimeAsHoursMinutes", formatTimeAsHoursMinutes);

  return (
    <Form.Item
      required={isRequired}
      label={<div className="label_text">{label}</div>}
      validateStatus={validate}
      help={validMessage}
      className={className}
      tooltip={
        tooltipTitle && {
          title: tooltipTitle,
          placement: "topLeft",
          arrow: false,
          icon: <InfoIconOutlined />,
        }
      }
    >
      <Controller
        name={fieldName}
        control={control}
        defaultValue={defaultValue}
        rules={rules}
        render={({ field: { onChange, value } }) => (
          <>
            <TimePicker
              value={value}
              format={formatTimeAsHoursMinutes}
              onChange={onChange}
              changeOnScroll={false}
              needConfirm={true}
              showNow={false}
              minuteStep={5}
            />
            {optionalLabel && (
              <div className="optional-label">{optionalLabel}</div>
            )}
            {hintMessage && (
              <div
                className={warning ? "hint-label warning-label" : "hint-label"}
              >
                {hintMessage}
              </div>
            )}
          </>
        )}
      />
    </Form.Item>
  );
};
